// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incyia-sd-wrap {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.incyia-sd-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  min-width: 0;
}

.incyia-sd-option.is-value {
  gap: 8px;
}

.incyia-sd-option-label {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: inherit;
  line-height: 1.35;
  color: #0b1e2d;
}

.incyia-sd-option:not(.is-value) .incyia-sd-option-label {
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

/* Explicit actionable chip — not a cryptic icon */
.incyia-sd-setup-chip {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  border: 1px solid #f0c9c3;
  background: #fae6e3;
  color: #96271b;
  font-family: Lato, sans-serif;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.01em;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.14s, border-color 0.14s, transform 0.14s;
}

.incyia-sd-setup-chip:hover {
  background: #f5d0cb;
  border-color: #e8b4ad;
  transform: translateY(-0.5px);
}

.incyia-sd-setup-chip.is-value {
  height: 22px;
  padding: 0 7px;
  font-size: 10px;
}

/* Guided callout under the select. Copy keeps the full width;
   the button sits on its own row so a narrow field cannot crush the text. */
.incyia-sd-guide {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  column-gap: 12px;
  row-gap: 10px;
  align-items: start;
  padding: 12px 14px;
  border-radius: 10px;
  background: #fff8f6;
  border: 1px solid #f0c9c3;
  border-left: 3px solid #d14a3e;
}

.incyia-sd-guide-ico {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  background: #fae6e3;
  color: #d14a3e;
  flex-shrink: 0;
}

.incyia-sd-guide-copy {
  grid-column: 2;
  min-width: 0;
}

.incyia-sd-guide-title {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #96271b;
}

.incyia-sd-guide-body {
  margin: 3px 0 0;
  font-size: 12.5px;
  line-height: 1.45;
  color: #5f7484;
}

.incyia-sd-guide .detail-btn {
  grid-column: 2;
  justify-self: start;
  background: #d14a3e;
}

.incyia-sd-guide .detail-btn:hover {
  background: #96271b;
}

.incyia-sd__single-value {
  max-width: calc(100% - 8px) !important;
}

.incyia-sd__single-value .incyia-sd-option {
  max-width: 100%;
}

.incyia-sd__value-container {
  flex-wrap: nowrap !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/selectSubDomain.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,kDAAkD;AAClD;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,iEAAiE;AACnE;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;4EAC4E;AAC5E;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".incyia-sd-wrap {\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.incyia-sd-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  min-width: 0;\n}\n\n.incyia-sd-option.is-value {\n  gap: 8px;\n}\n\n.incyia-sd-option-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: inherit;\n  line-height: 1.35;\n  color: #0b1e2d;\n}\n\n.incyia-sd-option:not(.is-value) .incyia-sd-option-label {\n  white-space: normal;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n\n/* Explicit actionable chip — not a cryptic icon */\n.incyia-sd-setup-chip {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  height: 24px;\n  padding: 0 8px;\n  border-radius: 999px;\n  border: 1px solid #f0c9c3;\n  background: #fae6e3;\n  color: #96271b;\n  font-family: Lato, sans-serif;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.14s, border-color 0.14s, transform 0.14s;\n}\n\n.incyia-sd-setup-chip:hover {\n  background: #f5d0cb;\n  border-color: #e8b4ad;\n  transform: translateY(-0.5px);\n}\n\n.incyia-sd-setup-chip.is-value {\n  height: 22px;\n  padding: 0 7px;\n  font-size: 10px;\n}\n\n/* Guided callout under the select. Copy keeps the full width;\n   the button sits on its own row so a narrow field cannot crush the text. */\n.incyia-sd-guide {\n  display: grid;\n  grid-template-columns: 28px minmax(0, 1fr);\n  column-gap: 12px;\n  row-gap: 10px;\n  align-items: start;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #fff8f6;\n  border: 1px solid #f0c9c3;\n  border-left: 3px solid #d14a3e;\n}\n\n.incyia-sd-guide-ico {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  background: #fae6e3;\n  color: #d14a3e;\n  flex-shrink: 0;\n}\n\n.incyia-sd-guide-copy {\n  grid-column: 2;\n  min-width: 0;\n}\n\n.incyia-sd-guide-title {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  color: #96271b;\n}\n\n.incyia-sd-guide-body {\n  margin: 3px 0 0;\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.incyia-sd-guide .detail-btn {\n  grid-column: 2;\n  justify-self: start;\n  background: #d14a3e;\n}\n\n.incyia-sd-guide .detail-btn:hover {\n  background: #96271b;\n}\n\n.incyia-sd__single-value {\n  max-width: calc(100% - 8px) !important;\n}\n\n.incyia-sd__single-value .incyia-sd-option {\n  max-width: 100%;\n}\n\n.incyia-sd__value-container {\n  flex-wrap: nowrap !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
